export const translations = {
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      projects: "المشاريع",
      articles: "المقالات",
      contact: "اتصل بنا",
      donate: "تبرع الآن",
      legalStatus: "الوضع القانوني",
      search: "ابحث برمز أو اسم المنتج...",
    },
    contact: {
      email: "orghhrdg2004@gmail.com",
      phone: "+970567225829",
    },
    hero: {
      title: "مؤسسة سند الخيرية",
      subtitle: "نسعى لبناء مستقبل أفضل من خلال مشاريعنا الخيرية والتنموية",
      donateBtn: "تبرع الآن",
      learnMore: "اعرف المزيد",
    },
    stats: {
      sponsoredChildren: "طفل مكفول",
      activeProjects: "مشاريع فعالة",
      beneficiaryFamilies: "عائلة مستفيدة",
      quickResponse: "استجابة سريعة",
    },
    values: {
      sectionTitle: "قيمنا",
      sectionDescription:
        "نلتزم في عملنا بمجموعة من القيم الأساسية التي توجه مسيرتنا",
      transparency: {
        title: "الشفافية",
        description: "نلتزم بالشفافية في جميع أعمالنا",
      },
      justice: {
        title: "العدالة",
        description: "نعزز العدالة الإنسانية للجميع",
      },
      sincerity: {
        title: "الإخلاص",
        description: "نعمل بإخلاص لخدمة المجتمع",
      },
      responsibility: {
        title: "المسؤولية",
        description: "نتحمل المسؤولية الاجتماعية",
      },
    },
    about: {
      title: "من نحن",
      heroTitle: "من نحن",
      heroSubtitle: 'الهيئة الإنسانية لإغاثة وتنمية غزة "سند"',
      sectionTitle: "نبذة عن الهيئة",
      paragraph1:
        "هي هيئة إنسانية تنموية مستقلة، غير ربحية تهتم بتقديم الإغاثة العاجلة، ودعم التنمية المستدامة، والمناصرة الإنسانية، وخدمة المجتمع الفلسطيني في قطاع غزة، مع تركيز خاص على الفئات الأكثر هشاشة وتضرراً في الحروب والأزمات الإنسانية.",
      paragraph2:
        "تعمل الهيئة وفق منهجية مهنية قائمة على الاستجابة السريعة، والتخطيط التنموي، وبناء الشراكات، والالتزام با��حوكمة الرشيدة، بما يضمن تعظيم الأثر الإنساني واستدامة التدخلات.",
      vision: "رؤيتنا",
      visionText:
        "أن تكون الهيئة الأولى في العالم العربي والإسلامي في دعم ومساندة الشعب الفلسطيني في غزة، من خلال العمل الإغاثي والتنموي والحقوقي والمجتمعي المستدام.",
      mission: "رسالتنا",
      missionText:
        'تسعى الهيئة الإنسانية لإغاثة وتنمية غزة "سند" إلى حشد الطاقات الشعبية والمدنية لدعم المجالات الإغاثية والتنموية والإرشادية والتعليمية في غزة، من خلال شراكات فعالة، وبرامج ميدانية، ومناصرة عادلة، وتسهم في تعزيز سبل العيش للفلسطينيين وتحقيق العدالة الإنسانية.',
    },
    projects: {
      title: "مشاريعنا",
      heroTitle: "مشاريعنا",
      heroSubtitle:
        "نعمل على مجموعة متنوعة من المشاريع الإغاثية والتنموية لخدمة المجتمع في غزة",
      departmentsTitle: "أقسام العمل",
      departmentsSubtitle: "تنظم الهيئة عملها من خلال عدة أقسام متخصصة",
      list: [
        {
          id: 1,
          title: "تنفيذ الدعم النفسي والاجتماعي للأطفال",
          description:
            "في ظل ما تخلفه الأزمات والصراعات من آثار نفسية واجتماعية عميقة، خاصة في أوقات الحروب والأزمات، تعمل الهيئة على تنفيذ برامج دعم نفسي واجتماعي مخصصة للأطفال، بهدف التخفيف من حدة الصدمات، وتعزيز الصحة النفسية، وبناء القدرة على التكيف.",
          fullText:
            'في ظل ما تخلفه الأزمات و الصراعات من آثار نفسية و إجتماعية عميقة ، خاصة في أوقات الحروب و الأزمات تعمل الهيئة الإنسانية "سند" على تنفيذ برامج دعم نفسي و إجتماعي مخصصة للأطفال ، بهدف التخفيف من حدة الصدمات ، و تعزيز الصحة النفسية ، و بناء القدرة على التكيف. تشمل هذه البرامج جلسات فردية و جماعية ، و أنشطة ترفيهية و تعليمية ، إضافة إلى دورات توعية نفسية ، تُقدم على يد مختصين في المجال ، كما تسعى الهيئة الإنسانية "سند" إلى خلق بيئة آمنة و داعمة تساعد الأطفال على إحساسهم بالأمان و الإستقرار ، و تعزيز تماسك المجتمع في مواجهة التحديات .',
        },
        {
          id: 2,
          title: "توزيع الخيام لأصحاب البيوت المهدمة",
          description:
            "توفر الهيئة الإنسانية سند خياماً للإيواء المؤقت لأصحاب المنازل التي دُمرت جراء الكوارث أو الحروب، بهدف تخفيف معاناتهم وتأمين مأوى آمن يحميهم من ظروف الطقس القاسية سواء من حر الصيف أو برودة الشتاء.",
          fullText:
            'توفر الهيئة الإنسانية "سند" خيام للإيواء المؤقت لأصحاب المنازل التي دُمرت جراء الكوارث أو الحروب ، بهدف تخفيف معاناتهم و تأمين مأوى آمن يحميهم من ظروف الطقس القاسية سواء من حر الصيف أو برودة الشتاء . كما تسعى الهيئة الإنسانية " سند" إلى تقديم الدعم المستمر لهذه الأُسر ، من خلال توفير الاحتياجات الأساسية و المساعدات العاجلة ، لتعزيز صمودهم و تمكينهم من تجاوز الأزمة بأمان و كرامة .',
        },
        {
          id: 3,
          title: "توزيع الطرود الغذائية",
          description:
            "توزع الهيئة الإنسانية سند طروداً غذائية متكاملة على الأسر المحتاجة والنازحة لسد بعضاً من احتياجاتهم ودعمهم وتوفير الالتزامات المعيشية.",
          fullText:
            'توزع الهيئة الإنسانية "سند" طروداً غذائية متكاملة على الأُسر المحتاجة ، و النازحة لسد بعضاً من احتياجاتهم و دعمهم و توفير الإلتزامات المعيشية .',
        },
        {
          id: 4,
          title: "مشروع توزيع المياه الصالحة للشرب المفلترة",
          description:
            "تعمل الهيئة على توزيع المياه الصالحة للشرب للأسر والمناطق التي تعاني من نقص في المياه، كما تشمل جهود الجمعية توزيع المياه على روضة قطر الندى، لضمان تلبية احتياجات مختلف فئات المجتمع.",
          fullText:
            'تعمل الهيئة على توزيع المياه الصالحة للشرب للأُسر و المناطق التي تعاني من نقص في المياه كما تشمل جهود الجمعية توزيع المياه على "روضة قطر الندى" ، لضمان تلبية احتياجات مختلف فئات المجتمع ، و تعزيز بيئة صحية و آمنة للمجتمع .',
        },
        {
          id: 5,
          title: "مشروع توزيع الخبز",
          description:
            "في إطار جهودها الرامية إلى تعزيز الأمن الغذائي و دعم الفئات الضعيفة: تنفيذ الهيئة مشروع توزيع خبز بشكل دوري ليستفيد منه الأطفال و الأُسر المحتاجة في المناطق الأكثر تضرراً.",
          fullText:
            'في إطار جهودها الرامية إلى تعزيز الأمن الغذائي و دعم الفئات الضعيفة : تنفيذ الهيئة مشروع توزيع خبز بشكل دوري ليستفيد منه الأطفال و الأُسر المحتاجة في المناطق الأكثر تضرراً و يُعد هذا المشروع استجابة مباشرة للواقع الصعب الذي تعيشه العديد من الأُسر التي تعاني من انعدام الأمن الغذائي كما تحرص الهيئة الإنسانية "سند" على الإشراف الدوري و المنتظم مع مكان تنفيذ المشرع لضمان الجودة و الإستمراية ، خاصة في أوقات الأزمات الإقتصادية أو النزوح .',
        },
        {
          id: 6,
          title: "حفر آبار مياه السبيل الغاطس وتشغيله",
          description:
            "أطلقت الجمعية مشروع حفر بئر مياه الغاطس وذلك بهدف توفير مصدر دائم ونظيف للمياه في المجتمعات المحتاجة لا سيما في المناطق التي تعاني من شح المياه.",
          fullText:
            'أطلقت الجمعية في حفر بئر مياه "الغاطس" و ذلك بهدف توفير مصدر دائم و نظيف لمياه في المجتمعات المحتاجة لا سيما في المناطق التي تعاني من شُح المياه فانطلقت الهيئة الإنسانية "سند" وبدأت بتنفيذ المشروع في منطقة الوسطى في السوارحة الغربية حيث أن سكان و نازحيين هذه المنطقة يعانون من قلة المياه و صعوبة في الحياة المعيشية ، و قد أسهمت هذه المبادرة في تحسين الظروف الصحية و المعيشية للسكان و التخفيف من معاناتهم اليومية في الحصول على المياه . تأتي هذه الجهود في إطار حرص الهيئة الإنسانية "سند" على توفير حياة كريمة و مستقرة للأسر المحتاجة في قطاع غزة .',
        },
        {
          id: 7,
          title: "كفالة ومساعدة الأيتام",
          description:
            "زارت الهيئة الإنسانية سند مدرسة قطر الندى، واطلعت على كشوفات أسماء الأطفال وحالتهم الاجتماعية فانطلقت بمشروع كفالة الأيتام في هذه المدرسة، من رسوم ومستلزمات دراسية وملابس ووجبات غذائية.",
          fullText:
            'زارت الهيئة الإنسانية "سند" مدرسة قطر الندى ، و إطلعت على كشوفات أسماء الأطفال و حالتهم الإجتماعية فانطلقت بمشروع كفالة الأيتام في هذه المدرسة ، من رسوم و مستلزمات دراسية و ملابس و وجبات غذائية كما تعمل الهيئة الإنسانية "سند" على توفير الرعاية الصحية و النفسية التي تهدف إلى تنمية قدراتهم و تأهيلهم ليكونوا أفراد فاعلين في المجتمع و اعتمادهم على أنفسهم ، مما يحسن جودة حياتهم بشكل مستدام .',
        },
        {
          id: 8,
          title: "مشروع إعادة بناء روضة ومدرسة قطر الندى بعد انتهاء الحرب",
          description:
            "عملت الهيئة الإنسانية سند بكل جهودها كي تبقي المسيرة التعليمية في داخل أطفال غزة، فإنطلقت بتنفيذ إعادة بناء روضة ومدرسة قطر الندى من خيام.",
          fullText:
            'عملت الهيئة الإنسانية " سند " بكل جهودها كي تبقي المسيرة التعليمية في داخل أطفال غزة ، فإنطلقت بتنفيذ إعادة بناء روضة و مدرسة قطر الندى من خيام . كما ساهمت الهيئة في توفير مدرسات ذو كفاءة عالية برواتب مناسبة لهذه الروضة ، مما يساعد الأطفال على التكيف مع التعلم من جديد و تنشيطهم و توفير لهم حياة كريمة خالية من الازمات.. كما حرصت هذه الجهود على تشغيل أيدي عاملة عاطلة عن العمل و توفير لهم رواتب شهرية مناسبة و حرت على تعليم أطفالنا فلذات أكبادنا نعم إنهم هم جيل المستقبل بل صناع المستقبل .',
        },
        {
          id: 9,
          title: "المساعدات الطارئة",
          description:
            "تقدم الهيئة الإنسانية سند دعماً طارئاً وشاملاً للنازحين في أوقات الأزمات وخاصة الحروب، ويشمل ذلك توفير المأوى المؤقت، وتوزيع المواد الغذائية وتقديم الخدمات الأساسية بما يتضمن كرامتهم.",
          fullText:
            'تقدم الهيئة الإنسانية "سند" دعماً طارئاً و شاملاً للنازحين في أوقات الأزمات و خاصة الحروب ، و يشمل ذلك توفير المأوي المؤقت ، و توزيع المواد الغذائية و تقديم الخدمات الأساسية بما يتضمن كرامتهم ، و يُسهم في تخفيف معاناتهم ، و الحفاظ على استقرارهم في ظل الظروف الإنسانية الصعبة .',
        },
      ],
      departments: [
        {
          icon: "🚨",
          title: "قسم الإغاثة والطوارئ",
          description:
            "تنسيق وتنفيذ مبادرات وحملات الإغاثة الغذائية والصحية والاستجابة السريعة للكوارث",
        },
        {
          icon: "🌱",
          title: "قسم التنمية والمشاريع المستدامة",
          description:
            "دعم مشاريع توليد الدخل وبرامج دعم التعليم والصحة والبنية التحتية",
        },
        {
          icon: "🧠",
          title: "قسم الإرشاد والتوعية",
          description:
            "جلسات دعم إرشادي وقانوني ونفسي فردي وجماعي للمتأثرين بالحرب",
        },
        {
          icon: "🎯",
          title: "قسم البرامج والمبادرات المجتمعية",
          description:
            "تنظيم فعاليات ثقافية وتعليمية ودعم مبادرات تطوعية وشبابية",
        },
        {
          icon: "📢",
          title: "قسم العلاقات العامة والإعلام",
          description:
            "نشر تقارير دورية عن أنشطة الهيئة وإدارة الحملات الإعلامية",
        },
        {
          icon: "⚖️",
          title: "قسم الشؤون القانونية والتوثيق",
          description:
            "توثيق الانتهاكات ضد المدنيين وإعداد تقارير قانونية دولية",
        },
      ],
    },
    legalStatus: {
      title: "الوضع القانوني للمؤسسة",
      heroTitle: "الوضع القانوني",
      heroSubtitle: "معلومات قانونية وإدارية عن الهيئة الإنسانية سند",
      basicInfo: "البيانات الأساسية",
      arabicName: "الاسم بالعربية",
      arabicNameValue: 'الهيئة الإنسانية لإغاثة وتنمية غزة "سند"',
      englishName: "الاسم بالإنجليزية",
      englishNameValue:
        'The humanitarian organization for relief and development in Gaza "Sanad"',
      address: "العنوان",
      addressValue: "دولة فلسطين - قطاع غزة - شارع الجلاء",
      workArea: "مكان العمل",
      workAreaValue: "في أنحاء محافظات قطاع غزة",
      contactPerson: "مسؤول الاتصال",
      contactPersonValue: "أ. فايق أيمن أبو عيشة",
      contactRole: "صفة مسؤول الاتصال",
      contactRoleValue: "المدير التنفيذي للمشاريع والتعاون الداخلي والدولي",
      organizationDef: "تعريف المؤسسة",
      organizationDefText:
        "هي هيئة إنسانية تنموية مستقلة، غير ربحية... تهتم بتقديم الإغاثة العاجلة، ودعم التنمية المستدامة، والمناصرة الإنسانية، وخدمة المجتمع الفلسطيني في قطاع غزة، مع تركيز خاص على الفئات الأكثر هشاشة وتضرراً في الحروب والأزمات الإنسانية. تعمل الهيئة وفق منهجية مهنية قائمة على الاستجابة السريعة، والتخطيط التنموي، وبناء الشراكات، والالتزام بالحوكمة الرشيدة، بما يضمن تعظيم الأثر الإنساني واستدامة التدخلات.",
      vision: "رؤية الهيئة",
      visionText:
        "أن تكون الهيئة الأولى في العالم العربي والإسلامي في دعم ومساندة الشعب الفلسطيني في غزة، من خلال العمل الإغاثي والتنموي والحقوقي والمجتمعي المستدام.",
      mission: "رسالة الهيئة",
      missionText:
        'تسعى الهيئة الإنسانية لإغاثة وتنمية غزة "سند" إلى حشد الطاقات الشعبية والمدنية لدعم المجالات الإغاثية والتنموية والإرشادية والتعليمية في غزة، من خلال شراكات فعالة، وبرامج ميدانية، ومناصرة عادلة، وتسهم في تعزيز سبل العيش للفلسطينيين وتحقيق العدالة الإنسانية.',
      targetGroup: "الفئة المستهدفة",
      targetGroupText:
        "تستهدف الهيئة في خدماتها الأطفال الأيتام، والأرامل، والأسر الفقيرة، والنساء، والفئات المهمشة، والنازحين، وأصحاب البيوت المهدمة، وغيرهم من كثير من الفئات المفتقرة والتي تحتاج لمساندة إنسانية.",
      values: "قيم الهيئة",
      valuesText:
        "نلتزم في عملنا بالشفافية، والنزاهة، والإخلاص، والعدالة، والالتزام، ونعزز المسؤولية المجتمعية، ونسعى نحو الاستدامة في مشاريعنا، ونعمل بروح الفريق بالتعاون والمشاركة لخدمة المجتمع.",
      strategicGoals: "الأهداف الاستراتيجية",
      goals: [
        "تقديم الدعم العاجل للمتضررين في غزة أثناء وبعد الأزمات والحروب",
        "تنفيذ مشاريع تنموية وتعليمية تعزز الاعتماد على الذات وتقلل من التبعية",
        "تقديم الدعم الإرشادي للضحايا، خصوصاً للفئات الهشة",
        "بناء شراكات محلية وإقليمية ودولية لدعم جهود الإغاثة والتنمية",
        "تعزيز الوعي العالمي بظروف ومعاناة غزة وأهلها من خلال الإعلام والمناصرة",
        "دعم المبادرات المجتمعية داخل غزة",
        "توثيق الانتهاكات وتعزيز الحقوق الإنسانية والمدنية للفلسطينيين",
      ],
    },
    contactPage: {
      title: "تواصل معنا",
      subtitle: "نحن هنا للإجابة على استفساراتكم ومساعدتكم",
      address: "العنوان",
      addressText: "دولة فلسطين - قطاع غزة - شارع الجلاء",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      formTitle: "نموذج الاستفسارات",
      formSubtitle: "املأ النموذج أدناه وسنتواصل معك في أقرب وقت ممكن",
      nameLabel: "الاسم الكامل",
      namePlaceholder: "أدخل اسمك الكامل",
      emailLabel: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      subjectLabel: "الموضوع",
      subjectPlaceholder: "موضوع الاستفسار",
      messageLabel: "الرسالة",
      messagePlaceholder: "اكتب رسالتك أو استفسارك هنا...",
      sendButton: "إرسال الرسالة",
      sendingButton: "جاري الإرسال...",
      successMessage: "تم فتح برنامج البريد الإلكتروني. يرجى إرسال الرسالة.",
      whatsappTitle: "تواصل معنا عبر واتساب",
      whatsappSubtitle:
        "يمكنكم التواصل المباشر مع فريقنا عبر واتساب للإجابة على استفساراتكم أو للحصول على المزيد من المعلومات",
      whatsappButton: "تواصل عبر واتساب",
    },
    donatePage: {
      title: "تبرع الآن",
      subtitle: "ساهم في إحداث فرق حقيقي في حياة الأسر المتضررة في غزة",
      donateNow: "تبرع الآن",
      learnMore: "اعرف المزيد",
      familiesHelped: "عائلة مستفيدة",
      loading: "جاري التحميل...",
      bankInfoSubtitle: "يمكنكم التبرع عبر التحويل البنكي المباشر",
      bankInfo: "معلومات البنك",
      bankName: "اسم البنك:",
      bankAddress: "العنوان:",
      swiftCode: "كود SWIFT:",
      beneficiary: "اسم المستفيد:",
      beneficiaryAddress: "عنوان المستفيد:",
      accountNumber: "رقم الحساب:",
      ibanTitle: "أرقام IBAN حسب العملة",
      cryptoTitle: "التبرع بالعملات الرقمية",
      cryptoSubtitle: "يمكنكم التبرع بشكل آمن وسريع عبر العملات الرقمية",
      walletAddress: "عنوان المحفظة",
      copyAddress: "نسخ العنوان",
      copiedAddress: "✓ تم النسخ",
      thankYouTitle: "شكراً لدعمكم",
      thankYouText: "تبرعاتكم تصنع فرقاً حقيقياً في حياة الأسر المحتاجة في غزة",
      contactButton: "تواصل معنا للاستفسار",
    },
    modal: {
      title: "الاستقلال والحياد",
      orgName: "سند",
      message:
        "هي منظمة تعمل باستقلالية تامة. نحن لا نتشارك مع أي من الأطراف المتورطة في النزاع، ولا نتلقى أي تمويل منهم. مهمتنا مكرسة حصرياً لسلامة ورفاهية المدنيين.",
      footerMessage: "رسالتنا واضحة: من الناس إلى الناس",
      button: "فهمت",
    },
    footer: {
      title: "الهيئة الإنسانية - سند",
      description:
        "هيئة إنسانية تنموية مستقلة تهتم بتقديم الإغاثة العاجلة ودعم التنمية المستدامة في غزة",
      quickLinks: "روابط سريعة",
      contactUs: "تواصل معنا",
      address: "دولة فلسطين - قطاع غزة",
      phoneLabel: "هاتف:",
      emailLabel: "البريد:",
      copyright:
        "© 2025 الهيئة الإنسانية لإغاثة وتنمية غزة - سند. جميع الحقوق محفوظة.",
    },
    chairmanMessage: {
      title: "كلمة رئيس الهيئة الإنسانية لإغاثة وتنمية غزة «سند»",
      name: "أيمن فايق أبو عيشة",
      position: "رئيس الهيئة",
      bismillah: "بسم الله الرحمن الرحيم،",
      content: `
        <p>في ظلّ ما يمرّ به قطاع غزة من ظروف إنسانية بالغة القسوة، وتحديات مركّبة ومتراكمة، تؤكّد الهيئة الإنسانية لإغاثة وتنمية غزة «سند» التزامها الراسخ بالوقوف إلى جانب أهلنا، وبذل أقصى الجهود لتخفيف معاناتهم، وتعزيز صمودهم، وصون كرامتهم الإنسانية.</p>
        
        <p>لقد تأسّست هيئة «سند» انطلاقًا من إيمان عميق بأن العمل الإنساني ليس مجرّد استجابة طارئة، بل مسؤولية أخلاقية ووطنية، ورسالة إنسانية سامية تقوم على مبادئ العطاء، والنزاهة، والشفافية، والشراكة الفاعلة، واستدامة الأثر. ومنذ انطلاقتنا، عملنا على تصميم وتنفيذ برامج إغاثية وتنموية تستجيب للاحتياجات العاجلة، وتؤسّس في الوقت ذاته لمسارات تنموية مستدامة، تمكّن الإنسان، وتعيد إليه الأمل بمستقبل أكثر كرامة وأمانًا، وذلك ضمن أطر واضحة من الحوكمة الرشيدة، والمعايير المهنية، والشفافية المؤسسية.</p>
        
        <p>وقد حرصنا على بناء نظام حوكمة متكامل ينظّم العلاقة بين المانحين وإدارة الهيئة، ويضمن أعلى مستويات المساءلة والرقابة، بما يكفل سلامة الإجراءات، ونزاهة الأداء، وفعالية البرامج والأنشطة المنفّذة.</p>
        
        <p>إننا في هيئة «سند» نعمل وفق رؤية إنسانية واضحة، ترتكز على خدمة الإنسان دون أيّ تمييز، وتعزيز التعاون مع شركائنا المحليين والدوليين، وتوظيف الموارد المتاحة بأقصى درجات الكفاءة والمسؤولية، بما يضمن وصول المساعدات إلى مستحقّيها، وتحقيق أثر ملموس ومستدام في حياة الفئات الأكثر احتياجًا.</p>
        
        <p>ونؤكّد أن ما تحقق من إنجازات ما كان له أن يرى النور لولا ثقة أهلنا، ودعم شركائنا، والجهود المخلصة التي تبذلها طواقمنا ومتطوّعونا، الذين يواصلون العمل في الميدان بروحٍ عالية وإخلاصٍ عميق، رغم التحديات الجسيمة والظروف الاستثنائية. لهم جميعًا نتقدّم بخالص الشكر وعظيم التقدير.</p>
        
        <p>وستواصل هيئة «سند»، بعون الله، أداء رسالتها الإنسانية، مستمدّة العزم من معاناة أهلنا، ومستلهِمة الأمل من إيماننا الراسخ بأن التضامن الصادق، والعمل المشترك، قادران على إحداث الفرق، وصناعة مستقبلٍ أكثر عدلًا وإنسانية.</p>
        
        <p><strong>والله وليّ التوفيق.</strong></p>
      `,
      signature: "رئيس الهيئة",
      organization: "الهيئة الإنسانية لإغاثة وتنمية غزة «سند»",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      projects: "Projects",
      articles: "Articles",
      contact: "Contact Us",
      donate: "Donate Now",
      legalStatus: "Legal Status",
      search: "Search by code or product name...",
    },
    contact: {
      email: "orghhrdg2004@gmail.com",
      phone: "+970567225829",
    },
    hero: {
      title: "Sanad Charitable Organization",
      subtitle:
        "We strive to build a better future through our charitable and development projects",
      donateBtn: "Donate Now",
      learnMore: "Learn More",
    },
    stats: {
      sponsoredChildren: "Sponsored Children",
      activeProjects: "Active Projects",
      beneficiaryFamilies: "Beneficiary Families",
      quickResponse: "Quick Response",
    },
    values: {
      sectionTitle: "Our Values",
      sectionDescription:
        "We are committed to a set of core values that guide our journey",
      transparency: {
        title: "Transparency",
        description: "We commit to transparency in all our work",
      },
      justice: {
        title: "Justice",
        description: "We promote human justice for all",
      },
      sincerity: {
        title: "Sincerity",
        description: "We work sincerely to serve the community",
      },
      responsibility: {
        title: "Responsibility",
        description: "We carry social responsibility",
      },
    },
    about: {
      title: "About Us",
      heroTitle: "About Us",
      heroSubtitle:
        'Humanitarian Organization for Relief and Development of Gaza "Sanad"',
      sectionTitle: "About the Organization",
      paragraph1:
        "It is an independent, non-profit humanitarian development organization that focuses on providing urgent relief, supporting sustainable development, humanitarian advocacy, and serving the Palestinian community in the Gaza Strip, with special focus on the most vulnerable groups affected by wars and humanitarian crises.",
      paragraph2:
        "The organization operates according to a professional methodology based on rapid response, developmental planning, partnership building, and commitment to good governance, ensuring the maximization of humanitarian impact and sustainability of interventions.",
      vision: "Our Vision",
      visionText:
        "To be the leading organization in the Arab and Islamic world in supporting and assisting the Palestinian people in Gaza, through sustainable relief, developmental, rights-based, and community work.",
      mission: "Our Mission",
      missionText:
        'The Humanitarian Organization for Relief and Development of Gaza "Sanad" seeks to mobilize popular and civil capacities to support relief, developmental, guidance, and educational fields in Gaza, through effective partnerships, field programs, fair advocacy, and contributing to enhancing the livelihoods of Palestinians and achieving humanitarian justice.',
    },
    projects: {
      title: "Our Projects",
      heroTitle: "Our Projects",
      heroSubtitle:
        "We work on a variety of relief and development projects to serve the community in Gaza",
      departmentsTitle: "Work Departments",
      departmentsSubtitle:
        "The organization organizes its work through several specialized departments",
      list: [
        {
          id: 1,
          title: "Psychosocial Support for Children",
          description:
            "Given the deep psychological and social effects left by crises and conflicts, especially during wars and crises, the organization implements psychosocial support programs dedicated to children, aimed at reducing the severity of trauma, promoting mental health, and building resilience.",
          fullText:
            "Given the deep psychological and social effects left by crises and conflicts, especially during wars and crises, the Sanad Humanitarian Organization implements psychosocial support programs dedicated to children, aimed at reducing the severity of trauma, promoting mental health, and building resilience. These programs include individual and group sessions, recreational and educational activities, in addition to psychological awareness courses, provided by specialists in the field. The Sanad Humanitarian Organization also seeks to create a safe and supportive environment that helps children feel safe and stable, and strengthens community cohesion in facing challenges.",
        },
        {
          id: 2,
          title: "Tent Distribution for Owners of Demolished Homes",
          description:
            "The Sanad Humanitarian Organization provides temporary shelter tents for owners of homes destroyed by disasters or wars, aiming to alleviate their suffering and secure safe shelter that protects them from harsh weather conditions, whether from summer heat or winter cold.",
          fullText:
            "The Sanad Humanitarian Organization provides temporary shelter tents for owners of homes destroyed by disasters or wars, aiming to alleviate their suffering and secure safe shelter that protects them from harsh weather conditions, whether from summer heat or winter cold. The Sanad Humanitarian Organization also seeks to provide continuous support to these families, by providing basic needs and urgent assistance, to enhance their resilience and enable them to overcome the crisis safely and with dignity.",
        },
        {
          id: 3,
          title: "Food Parcel Distribution",
          description:
            "The Sanad Humanitarian Organization distributes comprehensive food parcels to needy and displaced families to meet some of their needs, support them, and provide living commitments.",
          fullText:
            "The Sanad Humanitarian Organization distributes comprehensive food parcels to needy and displaced families to meet some of their needs, support them, and provide living commitments.",
        },
        {
          id: 4,
          title: "Filtered Drinking Water Distribution Project",
          description:
            "The organization works on distributing drinking water to families and areas suffering from water shortages. The organization's efforts also include distributing water to Qatar Al-Nada Kindergarten, to ensure meeting the needs of various community groups.",
          fullText:
            "The organization works on distributing drinking water to families and areas suffering from water shortages. The organization's efforts also include distributing water to Qatar Al-Nada Kindergarten, to ensure meeting the needs of various community groups, and to promote a healthy and safe environment for the community.",
        },
        {
          id: 5,
          title: "Bread Distribution Project",
          description:
            "As part of its efforts to enhance food security and support vulnerable groups, the organization implements a bread distribution project on a regular basis to benefit children and needy families in the most affected areas.",
          fullText:
            "As part of its efforts to enhance food security and support vulnerable groups, the organization implements a bread distribution project on a regular basis to benefit children and needy families in the most affected areas. This project is a direct response to the difficult reality experienced by many families suffering from food insecurity. The Sanad Humanitarian Organization is keen on regular and continuous supervision with the project implementation site to ensure quality and continuity, especially in times of economic crises or displacement.",
        },
        {
          id: 6,
          title: "Deep Water Well Drilling and Operation",
          description:
            "The organization launched a deep water well drilling project aimed at providing a permanent and clean source of water in needy communities, especially in areas suffering from water scarcity.",
          fullText:
            "The organization launched a deep water well drilling project aimed at providing a permanent and clean source of water in needy communities, especially in areas suffering from water scarcity. The Sanad Humanitarian Organization started implementing the project in the central area in Western Sawarha, where the residents and displaced people of this area suffer from water scarcity and difficulty in living conditions. This initiative contributed to improving the health and living conditions of the residents and alleviating their daily suffering in obtaining water. These efforts come within the framework of the Sanad Humanitarian Organization's keenness to provide a decent and stable life for needy families in the Gaza Strip.",
        },
        {
          id: 7,
          title: "Orphan Sponsorship and Assistance",
          description:
            "The Sanad Humanitarian Organization visited Qatar Al-Nada School, reviewed the lists of children's names and their social status, and launched an orphan sponsorship project in this school, including fees, school supplies, clothing, and food meals.",
          fullText:
            "The Sanad Humanitarian Organization visited Qatar Al-Nada School, reviewed the lists of children's names and their social status, and launched an orphan sponsorship project in this school, including fees, school supplies, clothing, and food meals. The Sanad Humanitarian Organization also works to provide health and psychological care aimed at developing their abilities and qualifying them to be active members of society and self-reliant, which improves their quality of life sustainably.",
        },
        {
          id: 8,
          title:
            "Rebuilding Qatar Al-Nada Kindergarten and School After the War",
          description:
            "The Sanad Humanitarian Organization worked with all its efforts to keep the educational journey within the children of Gaza, so it started implementing the reconstruction of Qatar Al-Nada Kindergarten and School from tents.",
          fullText:
            "The Sanad Humanitarian Organization worked with all its efforts to keep the educational journey within the children of Gaza, so it started implementing the reconstruction of Qatar Al-Nada Kindergarten and School from tents. The organization also contributed to providing highly qualified teachers with appropriate salaries for this kindergarten, which helps children adapt to learning again, activate them, and provide them with a decent life free from crises. These efforts were keen on employing unemployed workers and providing them with appropriate monthly salaries and were keen on educating our children, our livers. Yes, they are the future generation, even the makers of the future.",
        },
        {
          id: 9,
          title: "Emergency Assistance",
          description:
            "The Sanad Humanitarian Organization provides urgent and comprehensive support to displaced persons during crises, especially wars, including providing temporary shelter, distributing food items, and providing basic services while ensuring their dignity.",
          fullText:
            "The Sanad Humanitarian Organization provides urgent and comprehensive support to displaced persons during crises, especially wars, including providing temporary shelter, distributing food items, and providing basic services while ensuring their dignity, contributing to alleviating their suffering, and maintaining their stability in difficult humanitarian conditions.",
        },
      ],
      departments: [
        {
          icon: "🚨",
          title: "Relief and Emergency Department",
          description:
            "Coordinating and implementing relief initiatives and campaigns for food and health relief and rapid response to disasters",
        },
        {
          icon: "🌱",
          title: "Development and Sustainable Projects Department",
          description:
            "Supporting income-generating projects and programs supporting education, health, and infrastructure",
        },
        {
          icon: "🧠",
          title: "Guidance and Awareness Department",
          description:
            "Individual and group guidance, legal, and psychological support sessions for those affected by war",
        },
        {
          icon: "🎯",
          title: "Community Programs and Initiatives Department",
          description:
            "Organizing cultural and educational events and supporting volunteer and youth initiatives",
        },
        {
          icon: "📢",
          title: "Public Relations and Media Department",
          description:
            "Publishing periodic reports on the organization's activities and managing media campaigns",
        },
        {
          icon: "⚖️",
          title: "Legal Affairs and Documentation Department",
          description:
            "Documenting violations against civilians and preparing international legal reports",
        },
      ],
    },
    legalStatus: {
      title: "Legal Status of the Organization",
      heroTitle: "Legal Status",
      heroSubtitle:
        "Legal and administrative information about Sanad Humanitarian Organization",
      basicInfo: "Basic Information",
      arabicName: "Arabic Name",
      arabicNameValue:
        'The Humanitarian Organization for Relief and Development of Gaza "Sanad"',
      englishName: "English Name",
      englishNameValue:
        'The humanitarian organization for relief and development in Gaza "Sanad"',
      address: "Address",
      addressValue: "State of Palestine - Gaza Strip - Al-Jalaa Street",
      workArea: "Work Area",
      workAreaValue: "Throughout the governorates of the Gaza Strip",
      contactPerson: "Contact Person",
      contactPersonValue: "Mr. Faiq Ayman Abu Aisha",
      contactRole: "Contact Person Role",
      contactRoleValue:
        "Executive Director of Projects and Internal and International Cooperation",
      organizationDef: "Organization Definition",
      organizationDefText:
        "It is an independent, non-profit humanitarian development organization that focuses on providing urgent relief, supporting sustainable development, humanitarian advocacy, and serving the Palestinian community in the Gaza Strip, with special focus on the most vulnerable groups affected by wars and humanitarian crises. The organization operates according to a professional methodology based on rapid response, developmental planning, partnership building, and commitment to good governance, ensuring the maximization of humanitarian impact and sustainability of interventions.",
      vision: "Organization Vision",
      visionText:
        "To be the leading organization in the Arab and Islamic world in supporting and assisting the Palestinian people in Gaza, through sustainable relief, developmental, rights-based, and community work.",
      mission: "Organization Mission",
      missionText:
        'The Humanitarian Organization for Relief and Development of Gaza "Sanad" seeks to mobilize popular and civil capacities to support relief, developmental, guidance, and educational fields in Gaza, through effective partnerships, field programs, fair advocacy, and contributing to enhancing the livelihoods of Palestinians and achieving humanitarian justice.',
      targetGroup: "Target Group",
      targetGroupText:
        "The organization targets orphaned children, widows, poor families, women, marginalized groups, displaced persons, owners of demolished homes, and many other needy groups that require humanitarian support.",
      values: "Organization Values",
      valuesText:
        "We commit in our work to transparency, integrity, sincerity, justice, and commitment. We promote social responsibility, strive for sustainability in our projects, and work with a team spirit through cooperation and participation to serve the community.",
      strategicGoals: "Strategic Goals",
      goals: [
        "Providing urgent support to those affected in Gaza during and after crises and wars",
        "Implementing developmental and educational projects that enhance self-reliance and reduce dependency",
        "Providing guidance support to victims, especially vulnerable groups",
        "Building local, regional, and international partnerships to support relief and development efforts",
        "Enhancing global awareness of the conditions and suffering of Gaza and its people through media and advocacy",
        "Supporting community initiatives within Gaza",
        "Documenting violations and promoting the human and civil rights of Palestinians",
      ],
    },
    contactPage: {
      title: "Contact Us",
      subtitle: "We are here to answer your questions and help you",
      address: "Address",
      addressText: "State of Palestine - Gaza Strip - Al-Jalaa Street",
      phone: "Phone",
      email: "Email",
      formTitle: "Inquiry Form",
      formSubtitle:
        "Fill out the form below and we will contact you as soon as possible",
      nameLabel: "Full Name",
      namePlaceholder: "Enter your full name",
      emailLabel: "Email Address",
      emailPlaceholder: "Enter your email address",
      subjectLabel: "Subject",
      subjectPlaceholder: "Inquiry subject",
      messageLabel: "Message",
      messagePlaceholder: "Write your message or inquiry here...",
      sendButton: "Send Message",
      sendingButton: "Sending...",
      successMessage: "Email client opened. Please send the message.",
      whatsappTitle: "Contact Us via WhatsApp",
      whatsappSubtitle:
        "You can contact our team directly via WhatsApp to answer your questions or get more information",
      whatsappButton: "Contact via WhatsApp",
    },
    donatePage: {
      title: "Donate Now",
      subtitle:
        "Make a real difference in the lives of affected families in Gaza",
      donateNow: "Donate Now",
      learnMore: "Learn More",
      familiesHelped: "Families Helped",
      loading: "Loading...",
      bankInfoSubtitle: "You can donate via direct bank transfer",
      bankInfo: "Bank Information",
      bankName: "Bank Name:",
      bankAddress: "Address:",
      swiftCode: "SWIFT Code:",
      beneficiary: "Beneficiary Name:",
      beneficiaryAddress: "Beneficiary Address:",
      accountNumber: "Account Number:",
      ibanTitle: "IBAN Numbers by Currency",
      cryptoTitle: "Donate with Cryptocurrency",
      cryptoSubtitle: "You can donate safely and quickly via cryptocurrency",
      walletAddress: "Wallet Address",
      copyAddress: "Copy Address",
      copiedAddress: "✓ Copied",
      thankYouTitle: "Thank You for Your Support",
      thankYouText:
        "Your donations make a real difference in the lives of families in need in Gaza",
      contactButton: "Contact Us for Inquiries",
    },
    modal: {
      title: "Independence & Neutrality",
      orgName: "Sanad",
      message:
        "is an organization which operates with strict independence. We do not partner with, nor receive funding from, any parties involved in the conflict. Our mission is dedicated exclusively to the safety and well-being of civilians.",
      footerMessage: "Our message is clear: from people to people",
      button: "I Understand",
    },
    footer: {
      title: "Humanitarian Organization - Sanad",
      description:
        "An independent humanitarian development organization focused on providing urgent relief and supporting sustainable development in Gaza",
      quickLinks: "Quick Links",
      contactUs: "Contact Us",
      address: "State of Palestine - Gaza Strip",
      phoneLabel: "Phone:",
      emailLabel: "Email:",
      copyright:
        "© 2025 Humanitarian Organization for Relief and Development of Gaza - Sanad. All rights reserved.",
    },
    chairmanMessage: {
      title: "Message from the Chairman of Sanad Humanitarian Organization",
      name: "Ayman Fayeq Abu Aisha",
      position: "Chairman of the Organization",
      bismillah: "In the name of Allah, the Most Gracious, the Most Merciful,",
      content: `
        <p>In light of the extremely harsh humanitarian conditions and complex, accumulated challenges facing the Gaza Strip, the Humanitarian Organization for Relief and Development of Gaza "Sanad" affirms its steadfast commitment to standing by our people, making every effort to alleviate their suffering, strengthen their resilience, and preserve their human dignity.</p>
        
        <p>Sanad was established from a deep belief that humanitarian work is not merely an emergency response, but a moral and national responsibility, and a noble humanitarian mission based on the principles of giving, integrity, transparency, active partnership, and sustainable impact. Since our inception, we have worked to design and implement relief and development programs that respond to urgent needs while simultaneously establishing sustainable development pathways that empower people and restore their hope for a more dignified and secure future, all within clear frameworks of good governance, professional standards, and institutional transparency.</p>
        
        <p>We have been keen to build an integrated governance system that regulates the relationship between donors and the organization's management, ensuring the highest levels of accountability and oversight, which guarantees the integrity of procedures, the integrity of performance, and the effectiveness of implemented programs and activities.</p>
        
        <p>At Sanad, we work according to a clear humanitarian vision, centered on serving people without any discrimination, strengthening cooperation with our local and international partners, and deploying available resources with the utmost efficiency and responsibility, to ensure that aid reaches those who deserve it and achieves a tangible and sustainable impact on the lives of the most vulnerable groups.</p>
        
        <p>We affirm that the achievements made would not have seen the light of day without the trust of our people, the support of our partners, and the sincere efforts made by our staff and volunteers, who continue to work in the field with high spirits and deep dedication, despite the enormous challenges and exceptional circumstances. To all of them, we extend our sincere thanks and great appreciation.</p>
        
        <p>Sanad will continue, with God's help, to fulfill its humanitarian mission, drawing determination from the suffering of our people, and inspiration from our firm belief that sincere solidarity and joint action are capable of making a difference and creating a future that is more just and humane.</p>
        
        <p><strong>And Allah is the source of success.</strong></p>
      `,
      signature: "Chairman of the Organization",
      organization:
        'Humanitarian Organization for Relief and Development of Gaza "Sanad"',
    },
  },
};
